<template>
    <div>
        <div class="banner">
            <div>
                <h3>140MPa超高压宽温域</h3><h3>氢气密封性能检测平台</h3>
            </div>
        </div>
        <div class="content">
            <div class="common-title" id="title1">
                <div :class="{ 'introduct': true, 'fadeInUp': content1_title_animation }">
                    <div class="commit-tit">
                        <h3>平台介绍</h3>
                        <div class="small-text">Platform Introduction</div>
                    </div>
                </div>
            </div>
            <div class="common-content" id="content1">
                <div v-show="content1_content_animation"
                    :class="{ 'img-parent': true, 'fadeInLeft': this.content1_content_animation }">
                    <img class="img" :src="t1" />
                </div>
                <div v-show="content1_content_animation"
                    :class="{ 'introduct': true, 'fadeInRight': content1_content_animation }">
                    <div class="text">
                        <p> 140MPa超高压宽温域氢气密封性能检测平台的整体研制从增压系统、温控系统、密封检测系统等主要功用出发，突破了超高压与宽温域控制的设计瓶颈，并通过功能模块、元器件、管路的设计实现各环节间的有效连接。
                        </p>
                        <P>
                            由两个20尺集装箱组成，一个设置为操控区域，一个设置为测试区域。
                        </P>
                        <p>
                            检测平台整体占地面积达到194.53平方米
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="strip">
            <div class="content">
                <div class="common-title" id="title2">
                    <div v-show="content2_title_animation"
                        :class="{ 'introduct': true, 'fadeInUp': content2_title_animation }">
                        <div class="commit-tit">
                            <h3>平台参数</h3>
                            <div class="small-text">Platform Parameters</div>
                        </div>
                    </div>
                </div>
                <div class="common-content" id="content2">
                    <div v-show="content2_content_animation" :class="{ 'fadeInUp': content2_content_animation }"
                        style="width: 100%;">
                        <table>
                            <thead>
                                <tr>
                                    <th>名称</th>
                                    <th>具体内容</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>工况模拟</td>
                                    <td>140MPa超高压、-50℃~+160℃宽温域；</td>
                                </tr>
                                <tr>
                                    <td>适用对象</td>
                                    <td>金属、塑料、橡胶等标准件或密封圈；</td>
                                </tr>
                                <tr>
                                    <td>可测介质</td>
                                    <td>氢气、氦气、氮气、甲烷等气体；</td>
                                </tr>
                                <tr>
                                    <td>测试腔尺寸</td>
                                    <td>外径250mm、高度320mm、内径150mm、高度200mm；</td>
                                </tr>
                                <tr>
                                    <td>测试腔结构</td>
                                    <td>U型内腔结构设计；</td>
                                </tr>
                                <tr>
                                    <td>增压比</td>
                                    <td>一级为1：60，二级为1：150；</td>
                                </tr>
                                <tr>
                                    <td>控制或测试精度</td>
                                    <td>温度控制误差≤1%、压力控制误差≤0.5%、泄漏率测试误差；</td>
                                </tr>
                                <tr>
                                    <td>设备噪音等级</td>
                                    <td>≤75dB(距离设备1米处)；</td>
                                </tr>
                                <tr>
                                    <td>零部件安装方式</td>
                                    <td>低压卡套连接形式、高压锥面螺纹连接形式；</td>
                                </tr>
                                <tr>
                                    <td>电器功能</td>
                                    <td>可设定测试压力/温度、保压/保温时间等，<br>实时显示压力/温度/泄漏率一时间曲线、环境氢氧气浓度等。</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="content">
            <div class="common-title" id="title3">
                <div v-show="content3_title_animation" :class="{ 'introduct': true, 'fadeInUp': content3_title_animation }">
                    <div class="commit-tit">
                        <h3>主要功能</h3>
                        <div class="small-text">Major Function</div>
                    </div>
                </div>
            </div>
            <div class="common-content" id="content3">
                <div v-show="content3_content_animation" :class="{ 'fadeInUp': content3_content_animation }"
                    style="width: 100%;text-align: center;">
                    <img class="img" :src="t2" />
                </div>
            </div>
        </div>
        <div class="strip">
            <div class="content">
                <div class="common-title" id="title4">
                    <div v-show="content4_title_animation"
                        :class="{ 'introduct': true, 'fadeInUp': content4_title_animation }">
                        <div class="commit-tit">
                            <h3>平台创新点</h3>
                            <div class="small-text">Platform Innovation Points</div>
                        </div>
                    </div>
                </div>
                <div class="common-content" id="content4">
                    <div v-show="content4_content_animation" :class="{ 'fadeInUp': content4_content_animation }"
                        style="width: 100%;">
                        <el-row :gutter="10">
                            <el-col :span="8">
                                <div>
                                    <ul class="left">
                                        <li v-on:mouseenter="activeName = 1" :class="{ active: activeName == 1 }">气控系统</li>
                                        <li v-on:mouseenter="activeName = 2" :class="{ active: activeName == 2 }">氮气循环辅控系统</li>
                                        <li v-on:mouseenter="activeName = 3" :class="{ active: activeName == 3 }">快启式高压腔</li>
                                        <li v-on:mouseenter="activeName = 4" :class="{ active: activeName == 4 }">温控系统</li>
                                        <li v-on:mouseenter="activeName = 5" :class="{ active: activeName == 5 }">双级增压系统</li>
                                        <li v-on:mouseenter="activeName = 6" :class="{ active: activeName == 6 }">安全泄放系统</li>
                                    </ul>
                                </div>
                            </el-col>
                            <el-col :span="16" v-show="activeName == 1">
                                <div class="rcon">
                                    <img class="img" :src="t3" />
                                    <p>空气源控制，电、氢气完全实现“0”接触:</p>
                                    <ul class="right">
                                        <li>*气控阀并联集成</li>
                                        <li>*阀体响应时间≤01s</li>
                                        <li>*终端执行动作误差≤1%</li>
                                    </ul>
                                </div>
                            </el-col>
                            <el-col :span="16" v-show="activeName == 2">
                                <div class="rcon">
                                    <img class="img" :src="t6" />
                                    <p>气泵驱动构建“微正压”循环在线监测通路:</p>
                                    <ul class="right">
                                        <li>*圆筒形罩体结构设计</li>
                                        <li>*密封环境有效模拟</li>
                                        <li>*泄漏介质精准捕捉</li>
                                    </ul>
                                </div>
                            </el-col>
                            <el-col :span="16" v-show="activeName == 3">
                                <div class="rcon">
                                    <img class="img" :src="t7" />
                                    <p>高压盖旋转快启、密封件均匀受载的创新结构设计:</p>
                                    <ul class="right">
                                        <li>*安装省时、省力</li>
                                        <li>*密封方式可方便调整</li>
                                        <li>*减少机械结构对密封影响</li>
                                    </ul>
                                </div>
                            </el-col>
                            <el-col :span="16" v-show="activeName == 4">
                                <div class="rcon">
                                    <img class="img" :src="t8" />
                                    <p>螺旋油浴槽均匀换热，介质温度实时检测:</p>
                                    <ul class="right">
                                        <li>*平均升/降率4~8℃/min</li>
                                        <li>*换热过程热量损耗≤5%</li>
                                        <li>*液位报警，自动补液</li>
                                    </ul>
                                </div>
                            </el-col>
                            <el-col :span="16" v-show="activeName == 5">
                                <div class="rcon">
                                    <img class="img" :src="t9" />
                                    <p>空气源驱动的“双作用单级-双压缩”增压方式:</p>
                                    <ul class="right">
                                        <li>*平均加压速率为5~10MPa</li>
                                        <li>*气缸容积利用率≥95%</li>
                                        <li>*多类型加压模式</li>
                                    </ul>
                                </div>
                            </el-col>
                            <el-col :span="16" v-show="activeName == 6">
                                <div class="rcon">
                                    <img class="img" :src="t10" />
                                    <p>安全控制部件有序设计，辅助功能实时联演:</p>
                                    <ul class="right">
                                        <li>*超压/欠压/超温自动报警</li>
                                        <li>*断电自动卸荷</li>
                                        <li>*泄放动作逻辑自判断</li>
                                    </ul>
                                </div>
                            </el-col>
                        </el-row>

                    </div>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="common-title" id="title5">
                <div v-show="content5_title_animation" :class="{ 'introduct': true, 'fadeInUp': content5_title_animation }">
                    <div class="commit-tit">
                        <h3>线路示意图</h3>
                        <div class="small-text">Schematic Circuit</div>
                    </div>
                </div>
            </div>
            <div class="common-content" id="content5">
                <div v-show="content5_content_animation" :class="{ 'fadeInUp': content5_content_animation }"
                    style="width: 100%;text-align: center;">
                    <img class="img" :src="t5" />
                </div>
            </div>
        </div>
        <div class="strip">
            <div class="content">
                <div class="common-title" id="title6">
                    <div v-show="content6_title_animation"
                        :class="{ 'introduct': true, 'fadeInUp': content6_title_animation }">
                        <div class="commit-tit">
                            <h3>平台实物图</h3>
                            <div class="small-text">Physical Diagram of the Platform</div>
                        </div>
                    </div>
                </div>
                <div class="common-content" id="content6">
                    <div v-show="content6_content_animation" :class="{ 'fadeInUp': content6_content_animation }"
                        style="width: 100%;text-align: center;">
                        <template>
                            <el-carousel :interval="4000" type="card" :autoplay="false">
                                <el-carousel-item v-for="item in list" :key="item">
                                    <el-image style="width: 100%; height: auto" :src="item"></el-image>
                                </el-carousel-item>
                            </el-carousel>
                        </template>
                        <P style="margin-top:10px">140MPa超高压宽温域氢气密封性能检测平台实物图</P>
                    </div>
                </div>
            </div>
        </div>
        <!-- 锚点跳转 -->
        <div class="anchor-content">
            <div class="anchorLine"></div>
            <ul class="anchor" @click="skipContent">
                <li :class="{ 'active': anchor == '1' ? true : false }" data-name="title1">平台介绍</li>
                <li :class="{ 'active': anchor == '2' ? true : false }" data-name="title2">平台参数</li>
                <li :class="{ 'active': anchor == '3' ? true : false }" data-name="title3">主要功能</li>
                <li :class="{ 'active': anchor == '4' ? true : false }" data-name="title4">平台创新点</li>
                <li :class="{ 'active': anchor == '5' ? true : false }" data-name="title5">线路示意图</li>
                <li :class="{ 'active': anchor == '6' ? true : false }" data-name="title6">平台实物图</li>


            </ul>
        </div>
    </div>
</template>

<script>
// 导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'
export default {
    name: 'Safesystem',
    components: {

        // import引入的组件需要注入到对象中才能使用
    },
    data() {
        return {
            anchor: '',
            bannerUrl: require("@/assets/img/banner.png"),
            t1: require("@/assets/img/taijia/t1.png"),
            t2: require("@/assets/img/taijia/t2.png"),
            t3: require("@/assets/img/taijia/t3.png"),
            t5: require("@/assets/img/taijia/t5.png"),
            t6: require("@/assets/img/taijia/t6.png"),
            t7: require("@/assets/img/taijia/t7.png"),
            t8: require("@/assets/img/taijia/t8.png"),
            t9: require("@/assets/img/taijia/t9.png"),
            t10: require("@/assets/img/taijia/t10.png"),
            dui: require("@/assets/img/safe/dui.png"),
            activeName: 1,
            content1_title_animation: false, content1_content_animation: false,
            content2_title_animation: false, content2_content_animation: false,
            content3_title_animation: false, content3_content_animation: false,
            content4_title_animation: false, content4_content_animation: false,
            content5_title_animation: false, content5_content_animation: false,
            content6_title_animation: false, content6_content_animation: false,
            list: [
                require("@/assets/img/taijia/1.png"),
                require("@/assets/img/taijia/2.png"),
                require("@/assets/img/taijia/3.png"),
                require("@/assets/img/taijia/4.png"),
                require("@/assets/img/taijia/5.png"),
                require("@/assets/img/taijia/6.png"),
                require("@/assets/img/taijia/7.png")
            ]
        }
    },
    created() {
        window.onscroll = false;
    },
    mounted() {
        this.$nextTick(() => {
            this.scroll();
            window.addEventListener('scroll', this.scroll)
        })
    },
    methods: {
        scroll() {
            var a = [1, 2, 3];
            const docScrollTop = document.documentElement.scrollTop - 175;

            const title1_elOffsetTop = document.getElementById("title1").offsetTop;
            const content1_elOffsetTop = document.getElementById("content1").offsetTop;
            if (title1_elOffsetTop >= docScrollTop && title1_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content1_title_animation = true;
            }
            if (content1_elOffsetTop >= docScrollTop && content1_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content1_content_animation = true;
            }
            const title2_elOffsetTop = document.getElementById("title2").offsetTop;
            const content2_elOffsetTop = document.getElementById("content2").offsetTop;
            if (title2_elOffsetTop >= docScrollTop && title2_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content2_title_animation = true;
            }
            if (content2_elOffsetTop >= docScrollTop && content2_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content2_content_animation = true;
            }
            const title3_elOffsetTop = document.getElementById("title3").offsetTop;
            const content3_elOffsetTop = document.getElementById("content3").offsetTop;
            if (title3_elOffsetTop >= docScrollTop && title3_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content3_title_animation = true;
            }
            if (content3_elOffsetTop >= docScrollTop && content3_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content3_content_animation = true;
            }
            const title4_elOffsetTop = document.getElementById("title4").offsetTop;
            const content4_elOffsetTop = document.getElementById("content4").offsetTop;
            if (title4_elOffsetTop >= docScrollTop && title4_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content4_title_animation = true;
            }
            if (content4_elOffsetTop >= docScrollTop && content4_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content4_content_animation = true;
            }
            //线路示意图
            const title5_elOffsetTop = document.getElementById("title5").offsetTop;
            const content5_elOffsetTop = document.getElementById("content5").offsetTop;
            if (title5_elOffsetTop >= docScrollTop && title5_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content5_title_animation = true;
            }
            if (content5_elOffsetTop >= docScrollTop && content5_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content5_content_animation = true;
            }
            //平台实物
            const title6_elOffsetTop = document.getElementById("title6").offsetTop;
            const content6_elOffsetTop = document.getElementById("content6").offsetTop;
            if (title6_elOffsetTop >= docScrollTop && title6_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content6_title_animation = true;
            }
            if (content6_elOffsetTop >= docScrollTop && content6_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content6_content_animation = true;
            }
        },
        //锚点跳转
        skipContent(e) {
            var target = e.target.dataset.name;
            let anchorElementHeight = document.getElementById(target).offsetTop;
            window.scrollTo({ top: anchorElementHeight - 70, behavior: 'smooth' });
            switch (target) {
                case 'title1':
                    this.anchor = '1'
                    break;
                case 'title2':
                    this.anchor = '2'
                    break;
                case 'title3':
                    this.anchor = '3'
                    break;
                case 'title4':
                    this.anchor = '4'
                    break;
                case 'title5':
                    this.anchor = '5'
                    break;
                case 'title6':
                    this.anchor = '6'
                    break;
                default:
                    break;
            }
        }


    },
}
</script>

<style scoped lang="less">
@keyframes an1 {
    0% {
        transform: rotateY(0deg);
    }

    50% {
        transform: rotateY(180deg);
        opacity: 0.5;
    }

    100% {
        transform: rotateY(360deg);
    }
}

@-webkit-keyframes an1

/* Safari 与 Chrome */
    {
    0% {
        transform: rotateY(0deg);
    }

    50% {
        transform: rotateY(180deg);
        opacity: 0.5;
    }

    100% {
        transform: rotateY(360deg);
    }
}

.fixd {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: space-Between;
    -webkit-justify-content: space-Between;
    -moz-box-pack: space-Between;
    -ms-flex-pack: space-Between;
    justify-content: space-Between;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}

.fadeInUp {
    animation: fadeInUp 1s;
    -webkit-animation-name: fadeInUp;
    animation-name: fadeInUp;
}

.fadeInLeft {
    animation: fadeInLeft 1s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.fadeInLeft0 {
    animation: fadeInLeft 1.2s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.fadeInLeft1 {
    animation: fadeInLeft 1.4s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.fadeInLeft2 {
    animation: fadeInLeft 1.6s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.fadeInLeft3 {
    animation: fadeInLeft 1.8s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.fadeInLeft4 {
    animation: fadeInLeft 2s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.title {
    width: 100%;
    text-align: center;
    margin-bottom: 40px;
}

.banner {
    background: url('~@/assets/img/taijia/banner.png') no-repeat;
    background-size: 100% 100%;
}

.content {
    .common-title {
        text-align: center;
        margin-bottom: 53px;
    }

    .common-content {
        .fixd();
        align-items: center;

        >div:first-child {
            width: 42%;
        }

        >div:last-child {
            width: 42%;
        }

        .text {
            font-size: 14px;
            line-height: 24px;
            color: #666;
            margin-top: 25px;
            text-align: justify;

        }
    }
}

#content2 {
    table {
        width: 100%;
        background-color: #fff;
        border-radius: 4px;

        tr {

            td:first-child {
                text-align: center;
            }

            td:last-child {
                text-align: left;
            }

            td,th {
                padding: 10px 6px;
                line-height: 26px;
            }
        }

        tr:nth-child(odd) {
            background-color: #e6f3ff;
        }

        thead {
            th {
                color: #fff;
                background-color: #2a8ceb;
            }

            th:first-child {
                width: 35%;
                text-align: center;
                border-top-left-radius: 4px;
            }

            th:last-child {
                text-align: left;
                border-top-right-radius: 4px;
            }
        }
    }

}

#content4 {
    ul.left {
        li {
            padding: 32px 40px;
            border: 1px solid #E6E6E6;
            margin-bottom: 10px;
            font-weight: bold;
            font-size: 1.6rem;
            &:hover,
            &.active {

                background: url('~@/assets/img/taijia/t4.png') no-repeat;
                background-size: 100% 100%;
            }

            &:last-child {
                margin-bottom: 0;
            }
        }

    }

    img {
        width: 100%;
        margin-bottom:30px;
    }

    .rcon {
        padding: 39px 53px;
        background: #fff;

        p {
            color: #2895EA;
            line-height: 48px;
            font-size: 25px;
        }

        ul {
            li {
                height: 40px;
                line-height: 40px;
            }
        }
    }
}

.anchorLine {
    height: 210px;
}

.anchor {
    li::before {
        content: '';
        display: inline-block;
        height: 28px;
        width: 28px;
        margin-right: 10px;
        vertical-align: middle;

    }

    li:nth-child(1)::before {
        background: url('~@/assets/img/qtape/y1.png') no-repeat;
    }

    li:nth-child(1).active::before,
    li:nth-child(1):hover::before {
        background: url('~@/assets/img/qtape/y11.png') no-repeat;
    }

    li:nth-child(2)::before {
        background: url('~@/assets/img/qtape/y2.png') no-repeat;
    }

    li:nth-child(2).active::before,
    li:nth-child(2):hover::before {
        background: url('~@/assets/img/qtape/y22.png') no-repeat;
    }

    li:nth-child(3)::before {
        background: url('~@/assets/img/qtape/y3.png') no-repeat;
    }

    li:nth-child(3).active::before,
    li:nth-child(3):hover::before {
        background: url('~@/assets/img/qtape/y33.png') no-repeat;
    }

    li:nth-child(4)::before {
        background: url('~@/assets/img/qtape/y4.png') no-repeat;
    }

    li:nth-child(4).active::before,
    li:nth-child(4):hover::before {
        background: url('~@/assets/img/qtape/y44.png') no-repeat;
    }

    li:nth-child(5)::before {
        background: url('~@/assets/img/qtape/y5.png') no-repeat;
    }

    li:nth-child(5).active::before,
    li:nth-child(5):hover::before {
        background: url('~@/assets/img/qtape/y55.png') no-repeat;
    }

    li:nth-child(6)::before {
        background: url('~@/assets/img/qtape/y6.png') no-repeat;
    }

    li:nth-child(6).active::before,
    li:nth-child(6):hover::before {
        background: url('~@/assets/img/qtape/y66.png') no-repeat;
    }
}</style>



// WEBPACK FOOTER //
// src/components/page/taijia.vue